<template>
    <div id="check">
      <checklist-dashboard></checklist-dashboard>
    </div>
</template>

<script>

import checklistDashboard from "./ChecklistDashboard";

export default {
    name: "ChecklistLayout",
    components: {
        checklistDashboard,
    }
}
</script>

<style>

</style>
